export default "assets/dropdown-arrow-64a60ee3.svg";